"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[73812],{

/***/ 57579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ ResumeFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronDoubleUpIcon.js


function ChevronDoubleUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 4.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 6.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5zm.53 7.59l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 12.31z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(ChevronDoubleUpIcon);
/* harmony default export */ var esm_ChevronDoubleUpIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/EnvelopeIcon.js
var EnvelopeIcon = __webpack_require__(82123);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiGithub.js
var SiGithub = __webpack_require__(41416);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiLinkedin.js
var SiLinkedin = __webpack_require__(32159);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiTwitter.js
var SiTwitter = __webpack_require__(6714);
// EXTERNAL MODULE: ./components/link.tsx + 1 modules
var components_link = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/resume/use-resume-section-in-view.tsx
var use_resume_section_in_view = __webpack_require__(5851);
// EXTERNAL MODULE: ./utils/scroll-to.tsx
var scroll_to = __webpack_require__(76811);
;// CONCATENATED MODULE: ./components/resume/resume-mobile-footer.tsx










var ResumeFooter = function() {
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var ref1 = (0,use_resume_section_in_view/* useResumeSectionInView */.l)(), sections = ref1.sections, filter = ref1.filter, showSection = ref1.showSection, selectFilter = ref1.selectFilter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (0,clsx_m/* default */.Z)("fixed inset-x-0 bottom-0 z-40 px-4 py-2 transition-all ease-linear [--resume-footer-bg:theme(colors.gray.50)] print:!hidden lg:hidden", active ? "max-h-72" : "max-h-10"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute inset-0 h-full w-full shadow-xl shadow-gray-700 drop-shadow-2xl",
                style: {
                    background: "radial-gradient(61px 61px,#0000 24px,var(--resume-footer-bg) 0px) 0px -24px/100% 48px no-repeat, linear-gradient(0deg, transparent 0px, transparent 24px, var(--resume-footer-bg) 24px, var(--resume-footer-bg) 100%) 0px 24px/100% 100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-[calc(50%-24px)] border-t border-t-gray-900/10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 w-[calc(50%-24px)] border-t border-t-gray-900/10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-1/2 h-6 w-12 -translate-x-1/2 rounded-br-full rounded-bl-full border-b border-l border-r border-gray-900/10"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full border border-gray-100 bg-gray-50 p-3 text-gray-600 drop-shadow-md hf:text-gray-900 hf:drop-shadow",
                type: "button",
                onClick: function() {
                    return setActive(function(current) {
                        return !current;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Show Mobile Navigation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronDoubleUpIcon, {
                        className: (0,clsx_m/* default */.Z)("h-4 w-4 transition-all", active && "rotate-180")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "relative z-10 mt-8 grid grid-cols-2 pb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "spacing-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[13px] font-medium text-gray-700 d:text-gray-300",
                                children: "Filter view:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: "flex flex-wrap gap-1.5",
                                children: [
                                    "all",
                                    "relevant",
                                    "web / tech dev",
                                    "management",
                                    // "tech support",
                                    "entrepreneurial",
                                    "restaurant", 
                                ].map(function(type) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: (0,clsx_m/* default */.Z)("rounded border  px-1.5 py-0.5 text-xs font-medium outline-none hfa:outline-none ", filter.includes(type) ? "border-sky-300 bg-sky-100 text-gray-700 hf:border-sky-400 hf:bg-sky-300/40 hf:text-gray-800 d:border-sky-700 d:bg-sky-900/60 d:text-gray-200 d:hf:bg-sky-700/50 d:hf:text-gray-100" : "border-gray-200 bg-gray-100 text-gray-400 hf:border-gray-300 hf:bg-gray-200 hf:text-gray-700 d:border-gray-700 d:bg-gray-800 d:text-gray-300 d:hf:border-gray-600 d:hf:bg-gray-700 d:hf:text-gray-100"),
                                        onClick: function() {
                                            selectFilter(type);
                                            (0,scroll_to/* scrollToY */.d)(150, 0);
                                        },
                                        children: type
                                    }, type);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "mt-2 justify-end spacing-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                className: "flex flex-wrap gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        href: "mailto:hello@flext.dev",
                                        target: "_blank",
                                        className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                        "data-tip": "hello@flext.dev",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Email me"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvelopeIcon/* default */.Z, {
                                                className: "h-4 w-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        href: "https://github.com/FelixTellmann",
                                        target: "_blank",
                                        "data-tip": "Github",
                                        className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Github"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiGithub/* SiGithub */.p, {
                                                className: "h-4 w-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        href: "https://twitter.com/FelixTellmann",
                                        target: "_blank",
                                        "data-tip": "Twitter",
                                        className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Twitter"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiTwitter/* SiTwitter */.m, {
                                                className: "h-4 w-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        href: "https://www.linkedin.com/in/felixtellmann",
                                        target: "_blank",
                                        "data-tip": "LinkedIn",
                                        className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "LinkedIn"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiLinkedin/* SiLinkedin */.n, {
                                                className: "h-4 w-4"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "ml-1 text-[13px] text-gray-500 d:text-gray-400",
                                children: "Cape Town, South Africa"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 11245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ResumeSectionDateSidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);


var ResumeSectionDateSidebar = function(param) {
    var dateFrom = param.dateFrom, dateTo = param.dateTo, isLast = param.isLast, showDateRange = param.showDateRange, _sidebar = param.sidebar, sidebar = _sidebar === void 0 ? "" : _sidebar;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: "absolute top-1 left-[4.5rem] hidden h-full print:!left-4 print:!block md:block xl:left-6 2xl:left-4 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "absolute top-0 right-full pr-6 text-right text-xs font-medium leading-[16px] text-gray-400 print:!pr-8 print:!text-sm print:!text-gray-600 xl:pr-8",
                children: sidebar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "whitespace-nowrap",
                    children: sidebar
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: showDateRange ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "spacing-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "whitespace-nowrap print:!mr-0 xl:mr-2",
                                children: [
                                    (ref = new Date(dateFrom)) === null || ref === void 0 ? void 0 : ref.toLocaleDateString("en-GB", {
                                        month: "short",
                                        year: "numeric"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "hidden print:!inline xl:inline",
                                        children: " -"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "whitespace-nowrap",
                                children: Date.now() > new Date(dateTo).getTime() ? (ref1 = new Date(dateTo)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleDateString("en-GB", {
                                    month: "short",
                                    year: "numeric"
                                }) : "Current"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "whitespace-nowrap",
                        children: (ref2 = new Date(dateTo)) === null || ref2 === void 0 ? void 0 : ref2.toLocaleDateString("en-GB", {
                            year: "numeric"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-0 top-0 flex h-4 w-4 -translate-x-1/2 items-center justify-center rounded-full bg-gray-200 d:bg-gray-400",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-2 w-2 rounded-full bg-gray-400 d:bg-gray-700"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("absolute left-0 top-6 h-[calc(100%-2px)] w-0.5 -translate-x-1/2", isLast ? "bg-gradient-to-b from-gray-200 to-transparent d:from-gray-800 print:!via-gray-200" : "bg-gray-200 d:bg-gray-800")
            })
        ]
    });
};


/***/ }),

/***/ 58312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ResumeSectionDateEvents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_resume_use_resume_section_in_view__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5851);


var ResumeSectionDateEvents = function(param) {
    var name = param.name, organization = param.organization, city = param.city, country = param.country, dateFrom = param.dateFrom, dateTo = param.dateTo, showDateRange = param.showDateRange, description = param.description, responsibilities = param.responsibilities, _bullets = param.bullets, bullets = _bullets === void 0 ? true : _bullets;
    var ref, ref1, ref2;
    var filter = (0,components_resume_use_resume_section_in_view__WEBPACK_IMPORTED_MODULE_1__/* .useResumeSectionInView */ .l)().filter;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        className: "ml-0 spacing-1 print:!ml-12 md:ml-24 xl:ml-14 2xl:ml-12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                className: "items-baseline text-sm tracking-tight spacing-1 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!text-[18px] print:!font-semibold",
                        children: name
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "flex flex-wrap items-baseline gap-x-2 gap-y-0 print:!text-[16px]",
                        children: [
                            organization ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-semibold text-gray-600 d:text-gray-400",
                                        children: organization
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "select-none text-sm text-gray-300 print:!text-gray-500",
                                        children: "-"
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-gray-400/80 print:!text-gray-500",
                                children: city && country ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "hidden print:!inline sm:inline",
                                            children: [
                                                city,
                                                ","
                                            ]
                                        }),
                                        " ",
                                        country
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        city,
                                        country
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex gap-2 whitespace-nowrap text-xs font-semibold text-gray-500 d:text-gray-400 print:!hidden md:hidden",
                        children: showDateRange ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: (ref = new Date(dateFrom)) === null || ref === void 0 ? void 0 : ref.toLocaleDateString("en-GB", {
                                        month: "short",
                                        year: "numeric"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: Date.now() > new Date(dateTo).getTime() ? (ref1 = new Date(dateTo)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleDateString("en-GB", {
                                        month: "short",
                                        year: "numeric"
                                    }) : "Current"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: (ref2 = new Date(dateTo)) === null || ref2 === void 0 ? void 0 : ref2.toLocaleDateString("en-GB", {
                                year: "numeric"
                            })
                        })
                    })
                ]
            }),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-sm leading-relaxed text-gray-600",
                children: description
            }) : null,
            bullets ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "list-outside list-disc pl-4 text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!text-base",
                children: responsibilities.filter(function(param) {
                    var type = param.type;
                    return type.includes(filter) || filter === "all";
                }).map(function(responsibility, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "pl-3",
                        children: responsibility.content
                    }, index);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: responsibilities.filter(function(param) {
                    var type = param.type;
                    return type.includes(filter) || filter === "all";
                }).map(function(responsibility, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: " text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!text-base",
                        children: responsibility.content
                    }, index);
                })
            })
        ]
    });
};


/***/ }),

/***/ 74020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ ResumeSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronDownIcon.js


function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(ChevronDownIcon);
/* harmony default export */ var esm_ChevronDownIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/resume/use-resume-section-in-view.tsx
var use_resume_section_in_view = __webpack_require__(5851);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(17037);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useEffectOnce.js

var useEffectOnce = function (effect) {
    (0,react.useEffect)(effect, []);
};
/* harmony default export */ var esm_useEffectOnce = (useEffectOnce);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useUnmount.js


var useUnmount = function (fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    esm_useEffectOnce(function () { return function () { return fnRef.current(); }; });
};
/* harmony default export */ var esm_useUnmount = (useUnmount);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useRafState.js


var useRafState = function (initialState) {
    var frame = (0,react.useRef)(0);
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0,react.useCallback)(function (value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function () {
            setState(value);
        });
    }, []);
    esm_useUnmount(function () {
        cancelAnimationFrame(frame.current);
    });
    return [state, setRafState];
};
/* harmony default export */ var esm_useRafState = (useRafState);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/misc/util.js
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useWindowSize.js



var useWindowSize = function (initialWidth, initialHeight) {
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (initialHeight === void 0) { initialHeight = Infinity; }
    var _a = esm_useRafState({
        width: isBrowser ? window.innerWidth : initialWidth,
        height: isBrowser ? window.innerHeight : initialHeight,
    }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        if (isBrowser) {
            var handler_1 = function () {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            on(window, 'resize', handler_1);
            return function () {
                off(window, 'resize', handler_1);
            };
        }
    }, []);
    return state;
};
/* harmony default export */ var esm_useWindowSize = (useWindowSize);

;// CONCATENATED MODULE: ./utils/to-kebab-case.ts
var toKebabCase = function(str) {
    var ref;
    return (ref = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || ref === void 0 ? void 0 : ref.map(function(x) {
        return x.toLowerCase();
    }).join("-");
};

;// CONCATENATED MODULE: ./components/resume/resume-section.tsx








var ResumeSection = function(param) {
    var title = param.title, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    var sectionContentRef = (0,react.useRef)(null);
    var sectionRef = (0,react.useRef)(null);
    var centerVisible = (0,use_in_view/* useInView */.Y)(sectionRef, {
        margin: "-45% 0px -25% 0px"
    });
    var fullyVisible = (0,use_in_view/* useInView */.Y)(sectionRef, {
        amount: 0.9
    });
    var width = esm_useWindowSize().width;
    var ref = (0,use_resume_section_in_view/* useResumeSectionInView */.l)(), sections = ref.sections, filter = ref.filter, updateSection = ref.updateSection, toggleSectionShowing = ref.toggleSectionShowing, showSection = ref.showSection;
    var key = toKebabCase(title);
    var section = sections[key];
    (0,react.useEffect)(function() {
        if (sectionContentRef.current) {
            var element = sectionContentRef.current;
            element.style.maxHeight = element.clientHeight !== 0 ? "".concat(element.clientHeight, "px") : "";
        }
    }, []);
    (0,react.useEffect)(function() {
        var element = sectionContentRef.current;
        if (section.showing && element) {
            setTimeout(function() {
                element.style.maxHeight = "";
            }, 160);
            setTimeout(function() {
                element.style.maxHeight = element.clientHeight !== 0 ? "".concat(element.clientHeight, "px") : "";
            }, 500);
        }
    }, [
        key,
        section.showing,
        sections
    ]);
    (0,react.useEffect)(function() {
        var element = sectionContentRef.current;
        if (element && !element.classList.contains("!max-h-0") && element.style.maxHeight) {
            sectionContentRef.current.style.maxHeight = "";
        }
    }, [
        width,
        filter
    ]);
    (0,react.useEffect)(function() {
        updateSection(toKebabCase(title), section.showing, centerVisible, fullyVisible);
    }, [
        centerVisible,
        fullyVisible,
        section.showing,
        title,
        updateSection
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: toKebabCase(title),
        className: (0,clsx_m/* default */.Z)("relative -mx-4 scroll-mt-[122px] overflow-hidden px-4 spacing-4 print:!overflow-visible md:overflow-visible", className),
        ref: sectionRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "spacing-3 print:!-ml-24 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-baseline text-3xl font-bold tracking-tight text-gray-800 d:text-gray-100 print:!flex-1 print:!text-xl",
                                onClick: function() {
                                    return showSection(key);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "min-w-[105px]",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "ml-6 mr-24 hidden border-dashed border-gray-400 print:block print:!flex-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "group mr-2 ml-auto rounded p-2 text-gray-400/90 transition-colors hfa:outline-none hf:bg-gray-100 hf:text-gray-900 print:!hidden",
                                onClick: function() {
                                    return toggleSectionShowing(key);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Toggle Section Visibility"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronDownIcon, {
                                        className: (0,clsx_m/* default */.Z)("h-4 w-4 transition-all", section.showing ? "" : "rotate-180")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "h-px border-none bg-[linear-gradient(90deg,var(--line-color),var(--line-color)_50%,transparent_0,transparent)] bg-[length:8px_1px] [--line-color:theme(colors.gray.300/40)] d:[--line-color:theme(colors.gray.700/20)] print:!hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                ref: sectionContentRef,
                className: (0,clsx_m/* default */.Z)("relative transition-all duration-200 ease-linear print:!max-h-max", !section.showing && "!max-h-0 overflow-hidden opacity-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "transition-[all,height] delay-[0s,0.2s]"
                    }),
                    children
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useResumeSectionInView; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36902);


var useResumeSectionInView = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        sections: {
            intro: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            experience: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            projects: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            education: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            capabilities: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            certifications: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            references: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            },
            interests: {
                showing: true,
                centerVisible: false,
                fullyVisible: false
            }
        },
        filter: "relevant",
        selectFilter: function(filter) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(state) {
                state.filter = filter;
            }));
        },
        updateSection: function(id, showing, centerVisible, fullyVisible) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(state) {
                state.sections[id] = {
                    showing: showing,
                    centerVisible: centerVisible,
                    fullyVisible: fullyVisible
                };
            }));
        },
        toggleSectionShowing: function(id) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(state) {
                state.sections[id].showing = !state.sections[id].showing;
            }));
        },
        showSection: function(id) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(state) {
                state.sections[id].showing = true;
            }));
        }
    };
});


/***/ }),

/***/ 82123:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function EnvelopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(EnvelopeIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);